/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-11-10 14:37:17
 * @LastEditors: 
 * @LastEditTime: 2020-11-10 14:43:55
 */
import TreeSelect from './treeSelect';

export default TreeSelect